<template>
  <div class="sb-template">
    <div class="sb-template__header">
      <slot name="header" />
      <slot name="banner" />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SbTemplate',
};
</script>

<style lang='scss'>
	@import '@src/layout/Header/style/sb-template.scss';
</style>
